import { Tag } from '@carbon/react';
import {
  CheckmarkOutline,
  CircleDash,
  Close,
  InProgress,
} from '@carbon/react/icons';
import { FC } from 'react';
import style from './status-tag.module.scss';

export type PartyStatus =
  'not_started' | 'complete' | 'removed' | 'in_progress';

interface Props {
  status: PartyStatus;
  size?: 'sm' | 'md' | 'lg';
  progress?: string;
}

const LABELS: Record<PartyStatus, string> = {
  not_started: 'Not Started',
  in_progress: 'In Progress',
  complete: 'Complete',
  removed: 'Removed',
};

type TagType = 'gray' | 'blue' | 'outline' | 'red';

const TYPES: Record<PartyStatus, TagType> = {
  not_started: 'gray',
  in_progress: 'outline',
  complete: 'blue',
  removed: 'red',
};

const ICONS: Record<PartyStatus, React.ElementType> = {
  not_started: CircleDash,
  in_progress: InProgress,
  complete: CheckmarkOutline,
  removed: Close,
};

export const StatusTag: FC<Props> = ({ status, size = 'md', progress }) => {
  const Icon = ICONS[status];
  return (
    <Tag
      type={TYPES[status]}
      size={size}
      renderIcon={Icon}
      className={style.statusTag}
    >
      {progress ? `${LABELS[status]} (${progress})` : LABELS[status]}
    </Tag>
  );
};
